/* eslint-disable no-underscore-dangle */
import React from 'react';
import { inject, observer } from 'mobx-react';
import UserModel from '@/models/user';
import ViewBox, { sizeTypes, viewBoxType } from '../ViewBox';
import Style from './index.less';

interface ViewPanelProps {
  user?: UserModel;
}

const Only: React.FC<ViewPanelProps> = inject(({ store }) => {
  return {
    user: store.user,
  };
})(
  observer((props: ViewPanelProps) => {
    const { user } = props;
    return (
      <div className={`${Style['view-panel-wrap']} ${Style.lecturer}`}>
        <div className={Style['view-panel']}>
          <ViewBox
            key={`${user?.yxuid}only`}
            yxuid={String(user?.yxuid) || ''}
            type={viewBoxType.video}
            sizeType={sizeTypes.full}
          />
        </div>
      </div>
    );
  }),
);

export default Only;
